<template>
<div class="drummer">
  <div class="drummer__person"></div>
  <div class="drummer__drum"></div>
  <div class="drummer__hand-left"></div>
  <div class="drummer__hand-right"></div>
</div>
</template>

<script>
export default {
  name: 'drummer'
}
</script>

<style lang="scss">
@keyframes drummer-hand-left {
  0% {
    transform: translate3d(0,0%,0) rotate3d(0,0,0,0deg);
  }
  50% {
    transform: translate3d(0,-60%,0) rotate3d(0,0,1,20deg);
  }
  100% {
    transform: translate3d(0,0%,0) rotate3d(0,0,0,0deg);
  }
}
@keyframes drummer-hand-right {
  0% {
    transform: translate3d(0,0%,0) rotate3d(0,0,0,0deg);
  }
  50% {
    transform: translate3d(0,-60%,0) rotate3d(0,0,1,-20deg);
  }
  100% {
    transform: translate3d(0,0%,0) rotate3d(0,0,0,0deg);
  }
}
.drummer {
  position: relative;
  width: fluid(78px);
  height: fluid(135px);
  &__drum {
    position: absolute;
    bottom: 0;
    left: 0;
    width: fluid(78px);
    height: fluid(78px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/drum.svg');
  }
  &__person {
    position: absolute;
    top: 0;
    left: fluid(5px);
    width: fluid(68px);
    height: fluid(68px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/drummer.png');
  }
  &__hand-left {
    position: absolute;
    top: 40%;
    right: fluid(10px);
    width: fluid(22px);
    height: fluid(8px);
    border-radius: 50%;
    border: fluid(1px) solid #000;
    background-color: #663300;
  }
  &__hand-right {
    position: absolute;
    top: 40%;
    left: fluid(10px);
    width: fluid(22px);
    height: fluid(8px);
    border-radius: 50%;
    border: fluid(1px) solid #000;
    background-color: #663300;
  }
}
.play-drums {
  .drummer__hand-left {
    animation: drummer-hand-left 0.3s linear infinite;
  }
  .drummer__hand-right {
    animation: drummer-hand-right 0.3s 0.15s linear infinite;
  }
}
</style>